var __TEMP__ = require('./_baseToString.js');var baseToString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_castSlice.js');var castSlice = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_charsEndIndex.js');var charsEndIndex = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_stringToArray.js');var stringToArray = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./toString.js');var toString = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_trimmedEndIndex.js');var trimmedEndIndex = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */
function trimEnd(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.slice(0, trimmedEndIndex(string) + 1);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

  return castSlice(strSymbols, 0, end).join('');
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = trimEnd;
